import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";

import stickyScroll from "./features/sticky-scroll";

import { TabsPlugin } from "bootstrap-vue";
import lazyload from "./features/lazy-load";
import { analysisMixin } from "./vue/mixins/analysis";

lazyload();
stickyScroll();

initMain([analysisMixin], {}, [TabsPlugin]);
header();
